import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Button } from 'reactstrap';
import { escalateRequest } from '../../../services/api/cashless-vaccination';

const EscalateModal = ({
    requestId,
    isOpen,
    onClose,
    onComplete
}) => {

    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();

        if (onComplete) {
            setIsLoading(true);
            escalateRequest(requestId).then(() => {
                onComplete();
                setIsLoading(false);
            });
        }
        onClose();
    };

    return (
        <Modal isOpen={isOpen} toggle={onClose}>
            <ModalHeader toggle={onClose}>
                Escalate Request (Request ID: {requestId})
            </ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmit}>
                    <FormGroup>
                        <Label for="escalationReason">Are you sure you want to escalate this request?</Label>
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="danger" onClick={handleSubmit}>
                    Escalate
                </Button>{' '}
                <Button color="secondary" onClick={onClose}>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default EscalateModal;
